import classNames from 'classnames';
import HeaderDialog from 'components/foundation/dialogs/HeaderDialog/HeaderDialog';
import BasicNonNullPicker from 'components/foundation/pickers/basic-picker/BasicNonNullPicker/BasicNonNullPicker';
import { IBasicPickerValue } from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { t } from 'i18next';
import { useState } from 'react';
import { ClassName } from 'types/ClassName';
import './EquipmentIconLibraryDialog.scss';
import HeavyEquipmentIcons from './EquipmentIconRenders/HeavyEquipmentIcons';
import HighwayIcons from './EquipmentIconRenders/HighwayIcons';
import ToolIcons from './EquipmentIconRenders/ToolIcons';

export interface IEquipmentIconLibraryDialogProps {
  className?: ClassName;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (icon: any) => void;
}

export enum EquipmentIconType {
  HEAVY_EQUIPMENT = 'heavy-equipment',
  HIGHWAY = 'highway',
  TOOLS = 'tools',
}

const EquipmentIconLibraryDialog = (props: IEquipmentIconLibraryDialogProps) => {
  const { className, isOpen, onClose, onSubmit } = props;

  const [currentType, setCurrentType] = useState<EquipmentIconType>(EquipmentIconType.HEAVY_EQUIPMENT);

  const pickerOptions: IBasicPickerValue<EquipmentIconType>[] = [
    { name: t('Heavy Equipment'), id: EquipmentIconType.HEAVY_EQUIPMENT },
    { name: t('Highway'), id: EquipmentIconType.HIGHWAY },
    { name: t('Tools'), id: EquipmentIconType.TOOLS },
  ];

  const convertIconToFile = (imgDataUrl: string, fileName: string): File => {
    const byteString = atob(imgDataUrl.split(',')[1]);

    const byteArray = new Uint8Array(Array.from(byteString, (char) => char.charCodeAt(0)));

    const blob = new Blob([byteArray], { type: 'image/png' });

    return new File([blob], fileName, { type: 'image/png' });
  };

  const handleSubmit = (icon: string) => {
    onSubmit(convertIconToFile(icon, 'icon.png'));
    onClose();
  };

  const classes = classNames('equipment-icon-library-dialog', className);
  const renderIconList = () => {
    if (currentType === EquipmentIconType.HEAVY_EQUIPMENT) {
      return <HeavyEquipmentIcons onClick={handleSubmit} />;
    } else if (currentType === EquipmentIconType.HIGHWAY) {
      return <HighwayIcons onClick={handleSubmit} />;
    } else if (currentType === EquipmentIconType.TOOLS) {
      return <ToolIcons onClick={handleSubmit} />;
    }
  };

  return (
    <HeaderDialog title={t('Icon Library')} className={classes} isOpen={isOpen} onClose={onClose}>
      <div className="m-5">
        <BasicNonNullPicker value={currentType} onSelect={setCurrentType} data={pickerOptions} />
        {renderIconList()}
      </div>
    </HeaderDialog>
  );
};

export default EquipmentIconLibraryDialog;
